// src/components/RecenterButton.js
import React from 'react';
import { IconButton } from '@mui/material';
import IconRecenter from '../assets/icons/icon-recenter.svg';

export default function RecenterButton({ onClick, theme }) {
    return (
        <IconButton
            onClick={onClick}
            sx={{
                backgroundColor: theme.colors.blue,
                '&:hover': { backgroundColor: theme.colors.blue },
                width: 48,
                height: 48,
            }}
        >
            <img src={IconRecenter} alt="Recenter map" style={{ width: 24, height: 24 }} />
        </IconButton>
    );
}